module.exports = __webpack_public_path__ + "static/media/word-bubble-tail.02cc7c6f.png";